const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfettiSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 366.636 366.636",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB819"
    },
    points: "7.261,366.636 230.796,262.472 109.313,142.129  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD26C"
    },
    cx: 139.46,
    cy: 232.5,
    r: 27.121
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD26C"
    },
    d: "M64.791,240.073c7.507,0.439,15.158-2.219,20.866-7.982c10.454-10.552,10.455-27.525,0.076-38.087 L64.791,240.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD26C"
    },
    d: "M34.985,337.966c-5.319,5.371-7.93,12.403-7.847,19.408l44.797-20.876 C61.238,327.277,45.076,327.78,34.985,337.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD26C"
    },
    d: "M142.845,283.129c-6.434,6.495-8.903,15.423-7.436,23.792l47.484-22.127 c-0.534-0.634-1.093-1.252-1.693-1.846C170.559,272.407,153.387,272.488,142.845,283.129z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD26C"
    },
    cx: 77.177,
    cy: 286.451,
    r: 27.121
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#004D7A"
    },
    points: "96.306,170.743 202.305,275.748 230.796,262.472 109.313,142.129  "
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00BCB4"
    },
    cx: 135,
    cy: 86.679,
    r: 18.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00BCB4"
    },
    cx: 276.53,
    cy: 235.558,
    r: 18.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB819"
    },
    cx: 316.74,
    cy: 153.038,
    r: 18.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB819"
    },
    cx: 176.102,
    cy: 18.497,
    r: 18.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D85C72"
    },
    cx: 228.315,
    cy: 181.419,
    r: 18.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D85C72"
    },
    cx: 239.536,
    cy: 74.687,
    r: 18.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D85C72"
    },
    cx: 334.385,
    cy: 83.179,
    r: 18.497
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BCB4"
    },
    d: "M133.624,143.693c-3.767,0-6.819-3.053-6.819-6.819c0-3.766,3.052-6.819,6.819-6.819 c25.377,0,46.024-20.646,46.024-46.024c0-32.898,26.764-59.662,59.662-59.662c32.897,0,59.661,26.764,59.661,59.662 c0,3.766-3.053,6.818-6.818,6.818c-3.765,0-6.818-3.052-6.818-6.818c0-25.378-20.647-46.024-46.024-46.024 c-25.378,0-46.024,20.646-46.024,46.024C193.285,116.929,166.52,143.693,133.624,143.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB819"
    },
    d: "M312.259,210.037c-25.978,0-47.115-21.136-47.115-47.115c0-18.459-15.019-33.479-33.478-33.479 c-18.46,0-33.479,15.019-33.479,33.479c0,3.766-3.053,6.818-6.817,6.818c-3.767,0-6.819-3.052-6.819-6.818 c0-25.979,21.136-47.115,47.115-47.115c25.979,0,47.115,21.136,47.115,47.115c0,18.46,15.018,33.478,33.478,33.478 s33.478-15.018,33.478-33.478c0-3.766,3.054-6.818,6.82-6.818c3.764,0,6.817,3.052,6.817,6.818 C359.375,188.901,338.239,210.037,312.259,210.037z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiSvgrepoCom);
export default __webpack_public_path__ + "static/media/confetti-svgrepo-com.675e5f7eba7ef622632be78b35fd3909.svg";
export { ForwardRef as ReactComponent };